import pkg from '../../package.json' with { type: 'json' }

// /**
//  * @desc 获取作者
//  * @returns 作者名字
//  */
// function getAuthor() {
//   return pkg.author
// }

/**
 * @desc 获取版本号
 * @returns 版本号
 */
function getVersion() {
  return pkg.version
}

/**
 * @desc 获取描述
 * @returns 描述
 */
function getDescription() {
  return pkg.description
}

/**
 * @desc 获取许可证
 * @returns 许可证
 */
function getLicense() {
  return pkg.license
}

/**
 * @desc 获取包信息
 * @returns 包信息
 */
function getPkgInfo() {
  return pkg
}

export {
  // getAuthor,
  getDescription,
  getLicense,
  getPkgInfo,
  getVersion,
}
